import request from '@/utils/request'
import { getToken } from '../../utils/auth'

export function queryOrgHomeByOrgId (data) {
  return request({
    url: '/queryorghomebyorgid',
    method: 'post',
    params: { token: getToken() },
    data: {
      orgid: data.orgid
    }
  })
}

export function queryOrgHomeWithBedAndPerson (params, data) {
  params.token = getToken()
  return request({
    url: '/queryorghomewithbedandperson',
    method: 'post',
    params,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/yanglaoyuan/orgHome.js